import { Language, Messages, messagesIndex } from '../i18n';

export const useI18nMessaging = ({ language = 'en' }: { language?: Language } = {}): Messages =>
    messagesIndex[language];
